import { SettlementTypeEnum } from '../../../generated/api.graphql';

/** How a settlement is calculated. */
export const SettlementType = Object.freeze({
  ManualGbor: SettlementTypeEnum.ManualGbor,
  TicketSalesEvents: SettlementTypeEnum.TicketSalesEvents,
});

export type SettlementType = (typeof SettlementType)[keyof typeof SettlementType];
